export const SAVE_TO_SHORTLIST = "SAVE_TO_SHORTLIST";
export const RECEIVE_SHORTLIST_RESPONSE = "RECEIVE_SHORTLIST_RESPONSE";
export const INIT_SHORTLIST = "INIT_SHORTLIST";
export const RECEIVE_LATEST_SHORTLIST_DATA = "RECEIVE_LATEST_SHORTLIST_DATA";